module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Red Open .1304a77f.png";